/* eslint-disable complexity */
import { GetScheduleDataAddProps } from "../../../../models/add"
import {
  ScheduleDataAddType,
  ScheduleInfoAddType,
} from "../../../../models/add/DataAdd"
import { getScheduleDataTableAdd } from "../getDataTableAdd"
import { getScheduleInfoAdd } from "./getInfoAdd"

export const getScheduleDataAdd = async ({
  allCountries,
  dataSubmit,
  departments,
  detailDataSource,
  detailIndexIdentity,
  id,
  isFromSCR114UserSearch,
  isHiredLocally,
  isOtherStaffNumber,
  isSchedulesAdd,
  isSchedulesEdit,
  locationToSendMailList,
  lodgingIndexIdentity,
  notificationPersonAddressNameList,
  purposeTravelList,
  schedulesData,
  stayIndexIdentity,
  transportationList,
  travelerBase,
  travelerDetail,
  travelerId,
}: GetScheduleDataAddProps): Promise<ScheduleDataAddType> => {
  const scheduleInfoSubmit: ScheduleInfoAddType = isSchedulesEdit
    ? {
        travelScheduleId: id,
        ...getScheduleInfoAdd({
          dataSubmit,
          departments,
          isOtherStaffNumber,
          locationToSendMailList,
          notificationPersonAddressNameList,
          purposeTravelList,
          travelerId,
        }),
      }
    : getScheduleInfoAdd({
        dataSubmit,
        departments,
        isOtherStaffNumber,
        locationToSendMailList,
        notificationPersonAddressNameList,
        purposeTravelList,
        travelerBase,
        travelerDetail,
        travelerId,
      })

  const {
    schedulesAddDetailsSubmit,
    schedulesAddLodgingsSubmit,
    schedulesAddStaysSubmit,
  } = await getScheduleDataTableAdd({
    allCountries,
    dataSubmit,
    detailDataSource,
    detailIndexIdentity,
    id,
    isHiredLocally,
    isSchedulesAdd,
    isSchedulesEdit,
    lodgingIndexIdentity,
    schedulesData,
    stayIndexIdentity,
    transportationList,
  })

  return {
    details: schedulesAddDetailsSubmit,
    info: scheduleInfoSubmit,
    isFromSCR114UserSearch: isFromSCR114UserSearch,
    lodgings: schedulesAddLodgingsSubmit,
    stays: schedulesAddStaysSubmit,
  }
}
